import React from "react";
import {
    Dialog,
    DialogContent,
    styled,
    useTheme,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import Text from "components/mui/Text";
import AppButtonComponent from "components/mui/AppButtonComponent";
import ROUTES from "router/routes.constants";

const StyledDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialog-paper": {
        background: "#13172A",
        borderRadius: "16px",
        color: "#fff",
        maxWidth: 450,
        width: "100%",
        margin: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        position: "relative",
    },
    "& .MuiBackdrop-root": {
        backgroundColor: "rgba(0, 0, 0, 0.65)",
        backdropFilter: "blur(8px)",
    },
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    padding: theme.spacing(4, 3, 3, 3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
}));

const RiskAssessmentModal = ({ open = false, onClose }) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const handleRedirect = () => {
        onClose();
        navigate(ROUTES.RISK_ASSESSMENT);
    };

    return (
        <StyledDialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
        >
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 12,
                    top: 12,
                    color: 'rgba(255,255,255,0.6)',
                    '&:hover': { color: '#fff' }
                }}
            >
                <CloseIcon />
            </IconButton>
            <StyledDialogContent>
                <Text sx={{
                    fontWeight: 700,
                    fontSize: "20px",
                    color: "#fff",
                    mb: 2
                }}>
                    Risk Assessment Incomplete
                </Text>
                
                <Text sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: 1.5,
                    color: "rgba(255, 255, 255, 0.6)",
                    mb: 3.5
                }}>
                    Please complete your Risk Assessment to start investing in Direct Mutual Funds.
                </Text>

                <AppButtonComponent
                    variant="contained"
                    color="primary"
                    onClick={handleRedirect}
                    sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        fontWeight: 600,
                        fontSize: "14px",
                        px: 4,
                        py: 1,
                        width: "80%",
                    }}
                >
                    Complete Risk Assessment
                </AppButtonComponent>
            </StyledDialogContent>
        </StyledDialog>
    );
};

export default RiskAssessmentModal;
